import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { Flame } from "lucide-react";
import { API, axios } from "@/api";
import { BrandLogo } from "@/components/shared/BrandLogo";
import { useTheme } from "@/contexts/ThemeContext";

export default function TrendingInCity({ city }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { theme } = useTheme();

  useEffect(() => {
    axios.get(`${API}/offers/trending?limit=10`)
      .then(r => setItems(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading || items.length === 0) return null;

  return (
    <section className="mb-5 px-4" data-testid="trending-section">
      <div className="flex items-center justify-between mb-3">
        <h2 className="text-base font-bold text-slate-800 flex items-center gap-2">
          <Flame className="w-4 h-4 text-orange-500" />
          Trending in {city || "Your Area"}
        </h2>
      </div>
      <div className="space-y-2">
        {items.slice(0, 5).map((item, i) => (
          <motion.div
            key={item.business_id || i}
            initial={{ opacity: 0, x: -10 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: i * 0.06 }}
            whileTap={{ scale: 0.98 }}
            onClick={() => navigate(`/offer/${item.business_id}`)}
            className="flex items-center gap-3 p-3 bg-white rounded-xl border border-slate-100 shadow-sm cursor-pointer"
            data-testid={`trending-card-${item.business_id}`}
          >
            <span className="text-sm font-black text-slate-300 w-5 text-center">{i + 1}</span>
            <div className="w-9 h-9 rounded-lg bg-slate-50 flex items-center justify-center flex-shrink-0">
              <BrandLogo name={item.name} logoUrl={item.logo_url} size="sm" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-bold text-slate-800 truncate">{item.name}</p>
              <p className="text-[11px] text-slate-400">{item.category} · {item.offer_title || "Birthday deal"}</p>
            </div>
            {item.trending_score && (
              <span className="text-[10px] font-bold px-2 py-0.5 rounded-full" style={{ backgroundColor: `${theme.primary}15`, color: theme.primary }}>
                {item.trending_score} activity
              </span>
            )}
          </motion.div>
        ))}
      </div>
    </section>
  );
}
